import { render, staticRenderFns } from "./CampaignSetupsTCPAModal.vue?vue&type=template&id=55541b32"
import script from "./CampaignSetupsTCPAModal.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsTCPAModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports